import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import "./i18nextInit";

if (sessionStorage.getItem("react-token")) {
  let appConfig = {
    realm: sessionStorage.getItem("realm"),
    authURL: sessionStorage.getItem("authURL"),
    clientId: sessionStorage.getItem("clientId"),
    gatewayURL: sessionStorage.getItem("gatewayURL"),
    logoURL: sessionStorage.getItem("logoURL"),
  };
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <App config={appConfig} />
      </Router>
    </React.StrictMode>,
    document.getElementById("root")
  );
} else {
  sessionStorage.clear();
  fetch(`${window.location.origin}${window.location.pathname}.json`)
    .then(async (r) => r.json())
    .then((config) => {
      ReactDOM.render(
        <React.StrictMode>
          <Router>
            <App config={config} />
          </Router>
        </React.StrictMode>,
        document.getElementById("root")
      );
    })
    .catch((error) => {
      ReactDOM.render(<div>Error</div>, document.getElementById("root"));
    });
}
